import styled, { css } from 'styled-components';

import PickerDebounced from '~/src/common/components/PickerDebounced/PickerDebounced';
import type colors from '~/src/common/themes/main/colors';
import { tagStyle } from '~/src/screens/CatalogContent/ContentScreen/layout';
import { media } from '~/src/styles-constants';

export const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  z-index: 1;
  position: fixed;
  inset: auto 0 0;

  padding: 16px;
  padding-bottom: calc(env(safe-area-inset-bottom) + 16px);

  background: ${({ theme }) => theme.palette.background};
  border-top: ${({ theme }) => `1px solid ${theme.palette.common.BACKGROUND_3}`};

  ${media.M`
    position: initial;
    padding: 0;
  `}
`;

export const UnavailableContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  padding: 16px 0;
  font-weight: 500;
  width: 100%;
  line-height: 20px;
`;

export const PriceAndPromo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Price = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const ActualPrice = styled.span`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
`;

export const OriginalPrice = styled.div`
  font-size: 12px;
  line-height: 16px;
  text-decoration: line-through;
`;

export const Promo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const PromoTag = styled.div<{
  $promoBackgroundColor: keyof typeof colors;
  $promoColor: keyof typeof colors;
  $isBatchDiscount?: boolean;
}>`
  ${tagStyle};

  ${({ $isBatchDiscount }) => (!$isBatchDiscount ? 'font-size: 20px;' : '')};

  ${({ $isBatchDiscount }) => (!$isBatchDiscount ? media.M`font-size: 16px;` : '')};

  ${({ theme, $promoColor, $promoBackgroundColor }) => css`
    color: ${theme.palette.common[$promoColor]};
    background-color: ${theme.palette.common[$promoBackgroundColor]};
  `};

  &::first-letter {
    text-transform: uppercase;
  }
`;

export const PromoRange = styled.div`
  font-size: 12px;
  line-height: 16px;
`;

export const Picker = styled(PickerDebounced)`
  button {
    min-width: 42px;
    min-height: 42px;
  }
`;

export const PickerQuantity = styled.span`
  text-align: center;
  font-weight: 500;

  color: ${({ theme }) => theme.palette.common.BLACK};
  width: 48px;
  font-size: 20px;
`;
